module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7b97c5bb59e0139602708986bd21cfeb.gif";